export const SearchActions = {
    PERFORM_SEARCH: 'PERFORM_SEARCH',
    RETURN_SEARCH_RESULTS: 'RETURN_SEARCH_RESULTS',
    GET_REDIRECT: 'GET_REDIRECT',
    RETURN_REDIRECT: 'RETURN_REDIRECT',
    CLEAR_REDIRECT: 'CLEAR_REDIRECT'
};

export const performSearch = payload => ({
    type: SearchActions.PERFORM_SEARCH,
    payload
});

export const returnSearchResults = payload => ({
    type: SearchActions.RETURN_SEARCH_RESULTS,
    payload
});

export const getRedirect = payload => ({
    type: SearchActions.GET_REDIRECT,
    payload
});

export const returnRedirect = payload => ({
    type: SearchActions.RETURN_REDIRECT,
    payload
});

export const clearRedirect = () => ({
    type: SearchActions.CLEAR_REDIRECT,
});
